module.exports = __webpack_public_path__ + "media/images/vp/icon.url.red-00d81871e79dd86f09b72a148bc70a3a.svg";